export default "__VITE_ASSET__Dmqn2_4s__"